// extracted by mini-css-extract-plugin
export default {"_wrapper":"catbuttons__wrapper__zf5hO","category-item":"catbuttons_category-item__-xNKd"};